import { render, staticRenderFns } from "./examineItemsManage.vue?vue&type=template&id=621767da"
import script from "./examineItemsManage.vue?vue&type=script&lang=js"
export * from "./examineItemsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621767da')) {
      api.createRecord('621767da', component.options)
    } else {
      api.reload('621767da', component.options)
    }
    module.hot.accept("./examineItemsManage.vue?vue&type=template&id=621767da", function () {
      api.rerender('621767da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/examineItemsManage.vue"
export default component.exports